module.exports = __webpack_public_path__ + "img/mag (4).559c4052.png";